import React from "react"
import type { ParametrosDeliveryModel } from "../models/parametrosDeliveryModel"
import { ParametrosDeliveryInicial } from "../models/parametrosDeliveryModel"
import type { ParametrosDeliveryActionModel } from "./parametrosDeliveryActions"
import { parametrosDeliveryReducer } from "./parametrosDeliveryReducer"

type ParametrosDeliveryContextType = {
    parametros: ParametrosDeliveryModel
    dispatch: React.Dispatch<ParametrosDeliveryActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
}

export const ParametrosDeliveryContext = React.createContext<ParametrosDeliveryContextType>({
    parametros: ParametrosDeliveryInicial,
    dispatch: () =>
        parametrosDeliveryReducer(ParametrosDeliveryInicial, {
            type: "CARREGAR" as never,
            payload: ParametrosDeliveryInicial,
        }),
    salvar: async () => {},
    erroCarregamento: null,
})
